import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as TicketActions from '../../actions/ticket_actions';
import _ from 'lodash';
import Header from '../../components/header';
import TicketDetails from './ticketDetails';
import ReactPaginate from 'react-paginate';
import * as serviceCallConfig from './../../config/api_urls';
import { ModalDialogCommon } from './../modal_dialog_common';
import { CopyToClipboard } from 'react-copy-to-clipboard';

let screenIdentifier = 'tickets';

let Tickets = React.createClass({
    getInitialState() {
        return {
            ticketsData: [],
            currentTicket: {},
            activePage: 0,
            perPage: 10,
            selected: {
                name: 'Select',
                key: ''
            },
            roleId: 0,
            sort: { key: '', isAsc: 0 },
            openDropdown: false,
            isOpenTicketDetailsModal: false,
            copiedToClipboard: false
        }
    },
    componentWillMount() {
        let querParams = { page: this.state.activePage, size: this.state.perPage };
        if (this.props.LogingDetails.selectedUserRoleID === 2) {
            querParams['facilityId'] = this.props.LogingDetails.selectdUserFacilityID;
        }
        console.log('querParams', querParams, this.props.LogingDetails.selectedUserRoleID);

        this.getTicketsData(querParams);
    },
    getTicketsData(querParams) {
        this.props.Dispatch(TicketActions.getTickets(querParams));
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.LogingDetails && nextProps.LogingDetails.selectedUserRoleID) {
            this.setState({ roleId: nextProps.LogingDetails.selectedUserRoleID })
        }
        if (nextProps.TicketsData && nextProps.TicketsData.ticketsList) {
            this.setState({ ticketsData: nextProps.TicketsData.ticketsList, pageCount: Math.ceil(nextProps.TicketsData.ticketsList.totalElements / 10) });
        }
    },
    onClose() {
        this.setState({ isOpenTicketDetailsModal: false });
        let querParams = {};
        if (this.state.selected.key !== '') {
            // if (this.state.selected.key === 'Status') {

            //     let value = ('NEW').includes(this.refs.searchData.value.toUpperCase()) ? 8 : (('CLOSED').includes(this.refs.searchData.value.toUpperCase()) ? 9 : 10);
            //     querParams = { searchKey: this.state.selected.key, search: value};
            // } else {
            querParams = { searchKey: this.state.selected.key, search: this.refs.searchData.value.trim() };
            // }

        }
        if (this.state.sort.key !== '') {
            querParams['sortKey'] = this.state.sort.key;
            querParams['sort'] = this.state.sort.isAsc ? 'asc' : 'desc';
        }

        querParams['page'] = this.state.activePage;
        querParams['size'] = this.state.perPage;

        if (this.props.LogingDetails.selectedUserRoleID === 2) {
            querParams['facilityId'] = this.props.LogingDetails.selectdUserFacilityID;
        }
        console.log('querParams', querParams, this.props.LogingDetails.selectedUserRoleID);

        this.getTicketsData(querParams);
    },


    getDate(date) {
        if (date) {
            return (new Date(date)).toLocaleString().split(',')[0];
        } else {
            return 'N/A'
        }
    },



    handlePageClick(data) {
        let activePage = data.selected;
        this.setState({ activePage }, () => {
            this.getTicketsData({ page: data.selected, size: this.state.perPage });
        });
    },

    triggerTicket(ticket) {
        console.log(ticket);
        this.setState({ currentTicket: ticket, isOpenTicketDetailsModal: true });
    },

    sortData(key, form) {

    },
    openOptions() {
        this.setState({ openDropdown: !this.state.openDropdown });
    },

    handleChange(isSort, key, isAsc) {
        this.setState({ activePage: 0 });
        let querParams = ''

        if (this.refs.searchData.value !== '') {
            // if (this.state.selected.key === 'Status') {

            //     let value = ('NEW').includes(this.refs.searchData.value.toUpperCase()) ? 8 : (('CLOSED').includes(this.refs.searchData.value.toUpperCase()) ? 9 : 10);

            //     querParams = { searchKey: this.state.selected.key, search: value, page: 0, size: this.state.perPage };

            // } else {
            querParams = { searchKey: this.state.selected.key, search: this.refs.searchData.value.trim(), page: 0, size: this.state.perPage };
            // }
        } else {
            querParams = { page: this.state.activePage, size: this.state.perPage };
        }
        if (this.props.LogingDetails.selectedUserRoleID === 2) {
            querParams['facilityId'] = this.props.LogingDetails.selectdUserFacilityID;
        }
        if (isSort) {
            this.setState({ sort: { key: key, isAsc: isAsc } })
            querParams['sortKey'] = key;
            querParams['sort'] = isAsc ? 'asc' : 'desc';

        } else {
            this.setState({ sort: { key: '', isAsc: 0 } })
        }
        this.getTicketsData(querParams)
    },
    exportData() {
        // <a target="_self" href="http://52.53.160.193:8071/api/v1/public/tickets/export"></a>

        // this.props.Dispatch(TicketActions.exportData());
    },
    closeDropDown() {
        if (this.state.openDropdown) {
            this.setState({
                openDropdown: false
            })
        }

    },
    escalateTicket(event, ticketId) {
        event.stopPropagation();
        this.setState({ isOpenTicketDetailsModal: false });
        let data = "/" + `${ticketId}?isEscalated=true`;
        this.props.Dispatch(TicketActions.getStatus(data));
        let querParams = { page: this.state.activePage, size: this.state.perPage, facilityId: this.props.LogingDetails.selectdUserFacilityID };
        this.props.Dispatch(TicketActions.getTickets(querParams));
    },
    copyGuid(e) {
        e.preventDefault();
        e.stopPropagation();
    },
    copied() {
        this.setState({ copiedToClipboard: false })
    },
    onCopyText() {
        this.setState({ copiedToClipboard: true });
    },
    render() {

        return (
            <div>
                <header>
                    <Header screenIdentifier={screenIdentifier} />
                </header>
                <div className='right-content' onClick={() => { this.closeDropDown() }}>
                    <div className="dashboard-inner-content">
                        <div className='tickets_block'>
                            {/* <div className='due_ticket'>
                                <span className='due_name'>Due Today</span>
                                <span className='due_number'>20</span>
                            </div>
                            <div className='due_ticket'>
                                <span className='due_name'>Total Tickets</span>
                                <span className='due_number'>30</span>
                            </div> */}
                            <div className='due_ticket'>
                                <span className='due_name'>Total Tickets</span>
                                <span className='due_number'>{this.state.ticketsData.totalElements}</span>
                            </div>
                            {this.state.roleId == 1 &&
                                <div className='exportdata' onClick={this.exportData()}>
                                    <a target="_self" href={serviceCallConfig.BASE_URL + "public/tickets/export"}>Export Data</a>
                                    <span><i className='fa fa-file-text-o' aria-hidden="true"></i></span>
                                </div>
                            }
                            <div className='clearfix'></div>
                        </div>
                        <div className='staff_list filter_customer'>
                            <span className='icon-filter'></span>
                            <span>Filters</span>
                            <button className='select_staff' onClick={() => { this.openOptions() }}>{this.state.selected.name}
                                <span className='icon-dropdown'></span>
                            </button>
                            {this.state.openDropdown && <div className='filterselection_dropdown'>
                                <ul className='selected_dropdown_ul'>
                                    <li onClick={() => { this.setState({ selected: { name: 'Ticket ID', key: 'ticketId' }, openDropdown: false }) }}>Ticket ID</li>
                                    <li onClick={() => { this.setState({ selected: { name: 'User', key: 'Name' }, openDropdown: false }) }}>User</li>
                                    <li onClick={() => { this.setState({ selected: { name: 'Status', key: 'Status' }, openDropdown: false }) }}>Status</li>
                                    <li onClick={() => { this.setState({ selected: { name: 'Issue', key: 'Fault' }, openDropdown: false }) }}>Issue</li>
                                </ul>
                            </div>}
                            <div className="search_inputfeild_filter">
                                <input id='input' type={'text'} autoComplete='Off'
                                    ref='searchData' disabled={!(this.state.selected.key !== '')}
                                    className={!(this.state.selected.key !== '') ? 'search_staff' : 'search_staff1'} placeholder='Search' name='name'
                                    onKeyUp={(e) => {
                                        if ((['Ticket ID'].indexOf(this.state.selected.name) !== -1)) {
                                            if ((e.which > 47 && e.which < 58) || (e.which > 95 && e.which < 106) || e.key === 'Enter' || e.key === 'Backspace') {
                                                this.handleChange(false);
                                            }
                                        } else {
                                            this.handleChange(false);
                                        }
                                    }} />
                            </div>
                        </div>
                        <div className='tableScroll ticket-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th><div className='table_keys'><span>GUID</span></div></th>
                                        <th><div className='table_keys'><span>User</span></div></th>
                                        <th>
                                            <div className='table_keys'><span>Created Date</span>
                                                <div className='table_filter'>
                                                    <img className='upfilter' onClick={() => this.handleChange(true, 'cDt', true)} src={require('./../../../src/images/up.png')} />
                                                    <img className='upfilter' onClick={() => this.handleChange(true, 'cDt', false)} src={require('./../../../src/images/down.png')} />
                                                    {/* <span className='icon-downarrow ' ></span>
                                                    <span className='icon-downarrow downfilter' onClick={() => this.handleChange(true, 'c_dt', false)}></span> */}
                                                </div>
                                            </div>
                                        </th>
                                        <th>
                                            <div className='table_keys'><span>Status</span>
                                                <div className='table_filter'>
                                                    <img className='upfilter' onClick={() => this.handleChange(true, 'status', true)} src={require('./../../../src/images/up.png')} />
                                                    <img className='upfilter' onClick={() => this.handleChange(true, 'status', false)} src={require('./../../../src/images/down.png')} />
                                                </div>
                                            </div>
                                        </th>
                                        <th><div className='table_keys'><span>Issue</span></div></th>
                                        <th><div className='table_keys'><span>View/Edit</span></div></th>
                                        <th><div className='table_keys'><span>Escalate to Tech support</span></div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {_.map(this.state.ticketsData.content, (ticket, index) => <tr className='idcust_details' onClick={this.triggerTicket.bind(this, ticket)} key={ticket.id}>
                                        <td>
                                            <CopyToClipboard text={ticket.guid} onCopy={this.onCopyText}>
                                                <p className='guid ticket' title={'copy to clipboard'} onClick={(e) => { this.copyGuid(e) }}>{ticket.guid}</p>
                                            </CopyToClipboard>
                                            {/* <p className="guid ticket" title="copy to clipboard" onClick={(e) => { this.copyGuid(e, ticket.guid) }}>{ticket.guid}</p> */}
                                        </td>
                                        <td>{ticket.userName ? ticket.userName : 'Anonymous'}</td>
                                        <td>{this.getDate(ticket.cDt)}</td>
                                        <td>{ticket.status ? (ticket.status === 8 ? 'NEW' : (ticket.status === 9 ? 'CLOSED' : (ticket.status === 10 ? 'REOPEN' : 'IN PROGRESS'))) : 'N/A'}</td>
                                        <td>{ticket.faultName}</td>
                                        <td><i className="fa fa-eye view_tables" onClick={this.triggerTicket.bind(this, ticket)} aria-hidden="true"></i></td>
                                        <td>{ticket.escalated === true && <button className='escalated' disabled title='can not undo this action'>Escalated</button>}
                                            {ticket.escalated === false && <button className='escalate' onClick={(event) => { this.escalateTicket(event, ticket.id) }}>Escalate</button>}</td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                        {this.state.ticketsData && this.state.ticketsData.content && this.state.ticketsData.content.length > 0 && <ReactPaginate previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />}

                        {this.state.ticketsData && this.state.ticketsData.content && this.state.ticketsData.content.length == 0 && <div className='noData'>No Records Found</div>}
                    </div>

                </div>
                {this.state.isOpenTicketDetailsModal && <TicketDetails ticketData={this.state.currentTicket} onClose={() => { this.onClose() }} />}
                {this.state.copiedToClipboard && <ModalDialogCommon message={"Copied to clipboard"} action={this.copied} />}
            </div>
        );
    }
});

let mapStateToProps = (state) => {

    return {
        LogingDetails: state.User,
        TicketsData: state.Tickets
    };
};

let mapDispatchToProps = (dispatch) => ({
    TicketActions: bindActionCreators(TicketActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Tickets));



/** WEBPACK FOOTER **
 ** ./src/components/tickets/tickets.js
 **/